import { cloneDeep } from "lodash";
import { Order } from "./";

const DEFAULT_ATTRIBUTES = {
  events: [],
  feedbacks: [],
  order: {},
  support: false,
  valid_token: false,
};

export class Tracking {
  constructor(attributes) {
    const attrs = { ...cloneDeep(DEFAULT_ATTRIBUTES), ...attributes };

    Object.keys(attrs).forEach((key) => {
      this[key] = attrs[key];
    });

    if (this.order) {
      this.order = new Order(this.order);
    }
  }

  //? methods related with the orders.
  get isTrackingFinalStatus() {
    let validOrderStatuses = ["cancelled", "not_delivered", "delivered"];
    let validCheckinStatuses = [];

    if (this.order.isReturn) {
      if (this.order.isShipFull) {
        validOrderStatuses.push("shipped");
      } else {
        validCheckinStatuses.push("completed");
      }
    }

    return (
      validOrderStatuses.includes(this.order.status) ||
      (this.order.check_in &&
        validCheckinStatuses.includes(this.order.check_in.status))
    );
  }

  //? methods related with the visits.
  get isLastCompletedVisitNotDelivered() {
    return this.order.isLastCompletedVisitNotDelivered;
  }

  get isLastVisitNotDelivered() {
    return this.order.isLastVisitNotDelivered;
  }

  //? methods related with the shipping feedback.
  get isShippingFeedbackAllowed() {
    return this.isTrackingFinalStatus;
  }

  get isShippingFeedbackCompleted() {
    return this.feedbacks.some((feedback) => {
      return feedback.feedback_question.code === "shipping_csat";
    });
  }

  get shippingFeedbackRating() {
    const findedFeedback = this.feedbacks.find((feedback) => {
      return feedback.feedback_question.code === "shipping_csat";
    });

    return findedFeedback ? parseInt(findedFeedback.value) : -1;
  }

  //? methods related with the worker feedback.
  get isWorkerFeedbackAllowed() {
    const hasWorker = this.order.lastCompletedVisit?.driver_id !== null;
    const isValidStatus =
      this.isLastCompletedVisitNotDelivered || this.isTrackingFinalStatus;

    return this.order.hasNuntiusCarrier && isValidStatus && hasWorker;
  }

  get isWorkerFeedbackCompleted() {
    return this.feedbacks.some(
      (feedback) =>
        feedback.shipment_visit_id === this.order.lastCompletedVisit.id &&
        feedback.feedback_question.code === "worker_rating"
    );
  }

  get workerFeedbackRating() {
    const lastCompletedVisit = this.order.lastCompletedVisit;

    const findedFeedback = this.feedbacks.find(
      (feedback) =>
        feedback.shipment_visit_id === lastCompletedVisit.id &&
        feedback.feedback_question.code === "worker_rating"
    );

    return findedFeedback ? parseInt(findedFeedback.value) : 0;
  }

  //? methods related with the feedback.
  get isFeedbackAllowed() {
    return (
      this.valid_token &&
      (this.isShippingFeedbackAllowed || this.isWorkerFeedbackAllowed)
    );
  }

  get isFeedbackCompleted() {
    if (this.isShippingFeedbackAllowed) {
      //? validates only shipping feedback since the driver form is on the same screen,
      //? assuming both are completed.
      return this.isShippingFeedbackCompleted;
    }

    //? caso que solo tiene que completar el feedbak del conductor.
    return this.isWorkerFeedbackCompleted;
  }
}
